import styled, { css } from 'styled-components/macro';
import { VARIABLES } from 'styles/globals';
import { MOBILE_MAX_WIDTH } from 'utils/device';

interface StyledMapComponentProps {
  embeded?: boolean;
}

const measureTooltip = css`
  background-color: ${({ theme }) => theme.gray01};
  border: 1px solid ${({ theme }) => theme.gray03};
  color: ${({ theme }) => theme.textColor01};
  border-radius: ${VARIABLES.mapButtonBorderRadius};
  padding: 5px;
`;

export const StyledMapComponent = styled.div<StyledMapComponentProps>`
  width: 100%;
  height: 100%;
  position: relative;

  .ol-control {
    button {
      background-color: ${({ theme }) => theme.gray01};
      color: ${({ theme }) => theme.textColor01};
      border-radius: 0px;
      font-size: ${({ theme }) => theme.p2Size};
      font-style: normal;
      font-weight: 400;
      cursor: pointer;
      margin: 0px;

      @media screen and (max-width: ${MOBILE_MAX_WIDTH}) {
        color: ${({ theme }) => theme.iconColor09};
      }
    }

    button.active {
      background-color: ${({ theme }) => theme.brand03};
      color: ${({ theme }) => theme.textColor12};
      i {
        color: ${({ theme }) => theme.textColor12};
      }
    }
  }

  .ol-zoom {
    top: auto;
    left: auto;
    bottom: calc(${VARIABLES.mapButtonMargin} + ${VARIABLES.mapButtonSize});
    right: ${VARIABLES.mapButtonMargin};

    @media screen and (max-width: ${MOBILE_MAX_WIDTH}) {
      bottom: ${VARIABLES.mapButtonMargin};
    }

    button {
      font-family: 'Font Awesome 6 Pro';
    }

    .ol-zoom-in {
      ${({ embeded }) =>
        embeded === true
          ? css`
              border-top-left-radius: ${VARIABLES.mapButtonBorderRadius} !important;
              border-top-right-radius: ${VARIABLES.mapButtonBorderRadius} !important;
            `
          : css`
              border-top: 0px !important;

              @media screen and (max-width: ${MOBILE_MAX_WIDTH}) {
                border-top: 1px solid ${({ theme }) => theme.border2} !important;
                border-top-left-radius: ${VARIABLES.mapButtonBorderRadius};
                border-top-right-radius: ${VARIABLES.mapButtonBorderRadius};
              }
            `}
    }

    .ol-zoom-out {
      border-top: 0px !important;

      @media screen and (max-width: ${MOBILE_MAX_WIDTH}) {
        border-bottom-left-radius: ${VARIABLES.mapButtonBorderRadius};
        border-bottom-right-radius: ${VARIABLES.mapButtonBorderRadius};
      }
    }
  }

  .ol-embed {
    top: auto;
    bottom: ${VARIABLES.mapButtonMargin};
    right: ${VARIABLES.mapButtonMargin};
    button {
      border-bottom-left-radius: ${VARIABLES.mapButtonBorderRadius} !important;
      border-bottom-right-radius: ${VARIABLES.mapButtonBorderRadius} !important;
      border-top: 0;
    }
  }

  .measure-static-tooltip {
    ${measureTooltip};
    font-size: ${({ theme }) => theme.p1Size};
  }

  .measure-dynamic-tooltip {
    ${measureTooltip};
    font-size: ${({ theme }) => theme.p2Size};
  }

  .ol-popup {
    position: absolute;
    background-color: white;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    padding: 15px;
    border-radius: 10px;
    border: 1px solid #cccccc;
    bottom: 12px;
    left: -50px;
    min-width: 180px;
    max-width: 420px;
    font-size: ${({ theme }) => theme.p2Size};
  }
  .ol-popup:after,
  .ol-popup:before {
    top: 100%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  .ol-popup:after {
    border-top-color: white;
    border-width: 10px;
    left: 48px;
    margin-left: -10px;
  }
  .ol-popup:before {
    border-top-color: #cccccc;
    border-width: 11px;
    left: 48px;
    margin-left: -11px;
  }
  .ol-popup-closer {
    color: ${({ theme }) => theme.textColor01};
    text-decoration: none;
    position: absolute;
    top: 2px;
    right: 8px;
  }
  .ol-popup-closer:after {
    content: '✖';
  }
`;
